<template>
  <div class="englobe-params">
    <div class="params-row">
      <!-- Back to index -->
      <GoBackButton path="/jorfs" />

      <div
        v-if="store.previousJorfID || store.nextJorfID"
        class="previous-next-wrapper"
      >
        <!-- Next and Previous Items -->
        <RouterLink
          v-if="store.previousJorfID"
          v-focus
          :to="`/jorfs/${store.previousJorfID}`"
          class="btn-primary previous"
        >
          <i class="fa-solid fa-chevron-left" />Précédent
        </RouterLink>
        <RouterLink
          v-if="store.nextJorfID"
          v-focus
          :to="`/jorfs/${store.nextJorfID}`"
          class="btn-primary next"
        >
          Suivant<i class="fa-solid fa-chevron-right" />
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import GoBackButton from "@follaw-fr/components/general/atoms/GoBackButton.vue";
import { useJorfsStore } from "@follaw-fr/stores/jorfs";

const store = useJorfsStore();
</script>

<style lang="scss" scoped>
.previous-next-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
}
</style>
